import { isStubInDepthMarkdown } from './inDepthAnalysisSections';

const AT_GLANCE_PARTS = ['Summary', 'Keypoints', 'Speakers'];
const ARGUMENT_FIELDS = ['Explanation', 'Evidence', 'Major discussion point'];

const atGlanceMarkdown = (atGlance) => AT_GLANCE_PARTS
  .filter((part) => atGlance[part])
  .map((part) => `## ${part}\n\n${atGlance[part]}\n\n`)
  .join('')
  .trim();

const argumentMarkdown = (argumentName, argument) => `### ${argumentName}\n\n${ARGUMENT_FIELDS
  .filter((field) => argument[field])
  .map((field) => `**${field}:** ${argument[field]}\n\n`)
  .join('')}\n`;

const speakersMarkdown = (speakers) => Object.entries(speakers)
  .map(([speakerName, speakerArguments]) => `## ${speakerName}\n\n${Object.entries(speakerArguments)
    .map(([argumentName, argument]) => argumentMarkdown(argumentName, argument))
    .join('')}`)
  .join('')
  .trim();

/** The editable markdown fields stored on the session, in the language it was loaded in. */
export const sessionReportFields = (session) => ({
  session_at_glance_md: session.session_at_glance_md || session.sessionAtGlanceMd || '',
  full_report_md: session.full_report_md || session.fullReportMd || '',
  speakers_md: session.speakers_md || session.speakersMd || '',
  in_depth_md: session.in_depth_md || session.inDepthMd || '',
});

/**
 * Fills fields the session left empty from the generated report JSON, and passes
 * the in-depth analysis JSON along when the in-depth markdown is only a stub.
 */
export const withStoredReport = (fields, reportData) => {
  const filled = { ...fields };
  const sessionReport = reportData?.['Session report'];
  if (sessionReport) {
    const atGlance = sessionReport['Session at a glance'];
    if (!filled.session_at_glance_md && atGlance) {
      filled.session_at_glance_md = atGlanceMarkdown(atGlance) || filled.session_at_glance_md;
    }
    if (!filled.full_report_md && sessionReport['Full session report']) {
      filled.full_report_md = sessionReport['Full session report'];
    }
  }
  if (!filled.speakers_md && reportData?.Speakers) {
    filled.speakers_md = speakersMarkdown(reportData.Speakers) || filled.speakers_md;
  }
  const additionalAnalysis = reportData?.['Additional analysis'] || reportData?.['In-depth analysis'];
  if (isStubInDepthMarkdown(filled.in_depth_md) && additionalAnalysis) {
    filled.additional_analysis = additionalAnalysis;
  }
  return filled;
};
